import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { setDocumentTitle } from "helpers/documentTitle";

const DocumentTitle = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    setDocumentTitle(pathname);
  }, [pathname]);

  return null;
};

export default DocumentTitle;
